import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import OrgAtamaBilesi from '../components/OrgAtamaBilesi';

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '—';

const PersonelKartiPage = ({ kullaniciId, geriDon }) => {
  const { kullanici: benimKullanici } = useAuth();
  const [veri, setVeri] = useState(null);
  const [yoneticiler, setYoneticiler] = useState([]);
  const [sekme, setSekme] = useState(() => {
    const path = window.location.pathname;
    const alt = path.split('/')[3];
    return ['bilgiler','istihdam','performans','izinler','zimmetler'].includes(alt) ? alt : 'bilgiler';
  });

  React.useEffect(() => {
    if (kullaniciId) {
      window.history.replaceState({}, '', '/personel-listesi/' + kullaniciId + '/' + sekme);
      document.title = 'Personel Kartı - Valure HR';
    }
  }, [sekme, kullaniciId]);
  const [istihdamForm, setIstihdamForm] = useState({});
  const [istihdamDuzenle, setIstihdamDuzenle] = useState(false);
  const [kisiselForm, setKisiselForm] = useState({});
  const [kisiselDuzenle, setKisiselDuzenle] = useState(false);
  const [performansYil, setPerformansYil] = useState(new Date().getFullYear());
  const [performansForm, setPerformansForm] = useState({ genel_not: '', zam_orani: '', notlar: '', hedefler: [] });
  const [performansDuzenle, setPerformansDuzenle] = useState(false);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [egitimler, setEgitimler] = useState([]);
  const [zimmetler, setZimmetler] = useState([]);

  const rol = benimKullanici?.rol;
  const hrSuper = rol === 'admin' || rol === 'hr_super';

  const gorebilir = (alan) => {
    if (rol === 'admin' || rol === 'hr_super') return true;
    if (rol === 'yonetici') return ['bilgiler','istihdam','performans','izinler','zimmetler'].includes(alan);
    if (rol === 'hr') return ['bilgiler','izinler','zimmetler'].includes(alan);
    return false;
  };

  const duzenleyebilir = (alan) => {
    if (rol === 'admin' || rol === 'hr_super') return true;
    return false;
  };

  const yukle = () => {
    axios.get('/api/personel-karti/' + kullaniciId).then(r => {
      setVeri(r.data);
      const { kullanici: k } = r.data;
      setIstihdamForm({
        maas: k.maas || '',
        ise_giris_tarihi: k.ise_giris_tarihi || '',
        outsource: k.outsource ? true : false,
        outsource_firma: k.outsource_firma || '',
        outsource_baslangic: k.outsource_baslangic || '',
        yonetici_id: k.yonetici_id || ''
      });
      setKisiselForm({
        telefon: k.telefon || '',
        departman: k.departman || '',
        pozisyon: k.pozisyon || '',
        dogum_tarihi: k.dogum_tarihi || '',
        adres: k.adres || '',
        acil_iletisim_ad: k.acil_iletisim_ad || '',
        acil_iletisim_tel: k.acil_iletisim_tel || '',
      });
    }).catch(console.error);

    if (hrSuper) {
      axios.get('/api/personel-karti/liste/yoneticiler').then(r => setYoneticiler(r.data)).catch(console.error);
    }

    axios.get('/api/zimmet/personel/' + kullaniciId).then(r => setZimmetler(r.data)).catch(() => {});

    axios.get('/api/egitim/rapor/genel').then(r => {
      const personelEgitimler = (r.data.detay || []).filter(d => d.kullanici_id === parseInt(kullaniciId));
      setEgitimler(personelEgitimler);
    }).catch(console.error);
  };

  useEffect(() => { yukle(); }, [kullaniciId]);

  useEffect(() => {
    if (!veri) return;
    const mevcut = veri.performanslar.find(p => p.yil === performansYil);
    if (mevcut) {
      setPerformansForm({ genel_not: mevcut.genel_not || '', zam_orani: mevcut.zam_orani || '', notlar: mevcut.notlar || '', hedefler: mevcut.hedefler || [] });
    } else {
      setPerformansForm({ genel_not: '', zam_orani: '', notlar: '', hedefler: [] });
    }
  }, [performansYil, veri]);

  const handleKisiselKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/personel/' + kullaniciId + '/profil-admin', kisiselForm);
      setSonuc({ tip: 'basari', mesaj: 'Kişisel bilgiler güncellendi.' });
      setKisiselDuzenle(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleIstihdamKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/personel-karti/' + kullaniciId + '/istihdam', istihdamForm);
      setSonuc({ tip: 'basari', mesaj: 'İstihdam bilgileri güncellendi.' });
      setIstihdamDuzenle(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const handlePerformansKaydet = async () => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/personel-karti/' + kullaniciId + '/performans', { ...performansForm, yil: performansYil });
      setSonuc({ tip: 'basari', mesaj: 'Performans kaydedildi.' });
      setPerformansDuzenle(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const hedefEkle = () => setPerformansForm(p => ({ ...p, hedefler: [...p.hedefler, { hedef: '', hedef_oran: '', gerceklesme_oran: '' }] }));
  const hedefGuncelle = (idx, alan, deger) => setPerformansForm(p => ({ ...p, hedefler: p.hedefler.map((h, i) => i === idx ? { ...h, [alan]: deger } : h) }));
  const hedefSil = (idx) => setPerformansForm(p => ({ ...p, hedefler: p.hedefler.filter((_, i) => i !== idx) }));

  if (!veri) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yükleniyor...</div>;

  const { kullanici: k, performanslar, izinler } = veri;

  const aktifZimmetler = zimmetler.filter(z => z.durum === 'aktif');
  const gecmisZimmetler = zimmetler.filter(z => z.durum === 'iade');

  const sekmeler = [
    { key: 'bilgiler', label: 'Kişisel Bilgiler', goster: gorebilir('bilgiler') },
    { key: 'istihdam', label: 'İstihdam', goster: gorebilir('istihdam') },
    { key: 'performans', label: 'Performans', goster: gorebilir('performans') },
    { key: 'izinler', label: 'İzin Geçmişi', goster: gorebilir('izinler') },
    { key: 'zimmetler', label: `🖥️ Zimmetler${aktifZimmetler.length > 0 ? ` (${aktifZimmetler.length})` : ''}`, goster: gorebilir('zimmetler') },
  ].filter(s => s.goster);

  return (
    <div>
      {geriDon && <button className="btn btn-secondary btn-sm" onClick={geriDon} style={{ marginBottom: '1.5rem' }}>← Listeye Dön</button>}

      {/* Personel Başlığı */}
      <div className="card" style={{ marginBottom: '1.5rem', padding: '1.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="avatar" style={{ width: '56px', height: '56px', fontSize: '20px', flexShrink: 0 }} data-harf={k.ad[0] || '?'}>{k.ad[0]}{k.soyad[0]}</div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '2px' }}>{k.ad} {k.soyad}</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{k.pozisyon || '—'} {k.departman ? '· ' + k.departman : ''}</p>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{k.email}</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            {k.outsource ? <span className="badge badge-bekliyor">Outsource</span> : <span className="badge badge-tamamlandi">Dahili</span>}
            {hrSuper && k.maas && <div style={{ fontSize: '15px', fontWeight: '600', color: 'var(--mavi)', marginTop: '6px' }}>{Number(k.maas).toLocaleString('tr-TR')} TL</div>}
          </div>
        </div>
      </div>

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem', overflowX: 'auto' }}>
        {sekmeler.map(s => (
          <button key={s.key} onClick={() => { setSekme(s.key); setSonuc(null); setKisiselDuzenle(false); setIstihdamDuzenle(false); setPerformansDuzenle(false); }}
            style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: sekme === s.key ? '600' : '400', color: sekme === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === s.key ? '2px solid var(--mavi)' : '2px solid transparent', whiteSpace: 'nowrap' }}>
            {s.label}
          </button>
        ))}
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {/* KİŞİSEL BİLGİLER */}
      {sekme === 'bilgiler' && (
        <div>
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600' }}>Kişisel Bilgiler</h3>
              {duzenleyebilir('bilgiler') && !kisiselDuzenle && <button className="btn btn-secondary" onClick={() => setKisiselDuzenle(true)}>Düzenle</button>}
            </div>
            {!kisiselDuzenle ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem' }}>
                {[
                  { label: 'Telefon', value: k.telefon },
                  { label: 'Departman', value: k.departman },
                  { label: 'Pozisyon', value: k.pozisyon },
                  { label: 'Doğum Tarihi', value: fmt(k.dogum_tarihi) },
                  { label: 'Adres', value: k.adres },
                  { label: 'Acil İletişim', value: k.acil_iletisim_ad },
                  { label: 'Acil Telefon', value: k.acil_iletisim_tel },
                ].map(item => (
                  <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
                    <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>{item.label}</div>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value || '—'}</div>
                  </div>
                ))}
              </div>
            ) : (
              <form onSubmit={handleKisiselKaydet}>
                <div className="form-grid">
                  <div className="form-group"><label>Telefon</label><input type="tel" value={kisiselForm.telefon} onChange={e => setKisiselForm({ ...kisiselForm, telefon: e.target.value })} /></div>
                  <div className="form-group"><label>Departman</label><input type="text" value={kisiselForm.departman} onChange={e => setKisiselForm({ ...kisiselForm, departman: e.target.value })} /></div>
                  <div className="form-group"><label>Pozisyon</label><input type="text" value={kisiselForm.pozisyon} onChange={e => setKisiselForm({ ...kisiselForm, pozisyon: e.target.value })} /></div>
                  <div className="form-group"><label>Doğum Tarihi</label><input type="date" value={kisiselForm.dogum_tarihi} onChange={e => setKisiselForm({ ...kisiselForm, dogum_tarihi: e.target.value })} /></div>
                  <div className="form-group full"><label>Adres</label><textarea value={kisiselForm.adres} onChange={e => setKisiselForm({ ...kisiselForm, adres: e.target.value })} rows={2} /></div>
                  <div className="form-group"><label>Acil İletişim Kişisi</label><input type="text" value={kisiselForm.acil_iletisim_ad} onChange={e => setKisiselForm({ ...kisiselForm, acil_iletisim_ad: e.target.value })} /></div>
                  <div className="form-group"><label>Acil Telefon</label><input type="tel" value={kisiselForm.acil_iletisim_tel} onChange={e => setKisiselForm({ ...kisiselForm, acil_iletisim_tel: e.target.value })} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setKisiselDuzenle(false)}>İptal</button>
                </div>
              </form>
            )}
          </div>
          <OrgAtamaBilesi kullaniciId={kullaniciId} />
        </div>
      )}

      {/* İSTİHDAM */}
      {sekme === 'istihdam' && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600' }}>İstihdam Bilgileri</h3>
            {duzenleyebilir('istihdam') && !istihdamDuzenle && <button className="btn btn-secondary" onClick={() => setIstihdamDuzenle(true)}>Düzenle</button>}
          </div>
          {!istihdamDuzenle ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem' }}>
              {[
                { label: 'Maaş', value: istihdamForm.maas ? Number(istihdamForm.maas).toLocaleString('tr-TR') + ' TL' : '—' },
                { label: 'Valure İşe Giriş', value: fmt(istihdamForm.ise_giris_tarihi) },
                { label: 'İstihdam Türü', value: istihdamForm.outsource ? 'Outsource' : 'Dahili' },
                { label: 'Outsource Firma', value: istihdamForm.outsource_firma || '—' },
                { label: 'Müşteride Başlangıç', value: fmt(istihdamForm.outsource_baslangic) },
                { label: 'Yönetici', value: k.yonetici_ad ? k.yonetici_ad + ' ' + k.yonetici_soyad : '—' },
              ].map(item => (
                <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>{item.label}</div>
                  <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value}</div>
                </div>
              ))}
            </div>
          ) : (
            <form onSubmit={handleIstihdamKaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Maaş (TL)</label><input type="number" value={istihdamForm.maas} onChange={e => setIstihdamForm({ ...istihdamForm, maas: e.target.value })} /></div>
                <div className="form-group"><label>Valure İşe Giriş</label><input type="date" value={istihdamForm.ise_giris_tarihi} onChange={e => setIstihdamForm({ ...istihdamForm, ise_giris_tarihi: e.target.value })} /></div>
                <div className="form-group"><label>Yönetici</label>
                  <select value={istihdamForm.yonetici_id} onChange={e => setIstihdamForm({ ...istihdamForm, yonetici_id: e.target.value })}>
                    <option value="">— Seçin —</option>
                    {yoneticiler.map(y => <option key={y.id} value={y.id}>{y.ad} {y.soyad}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>İstihdam Türü</label>
                  <select value={istihdamForm.outsource ? '1' : '0'} onChange={e => setIstihdamForm({ ...istihdamForm, outsource: e.target.value === '1' })}>
                    <option value="0">Dahili</option>
                    <option value="1">Outsource</option>
                  </select>
                </div>
                {istihdamForm.outsource && (
                  <>
                    <div className="form-group"><label>Outsource Firma</label><input type="text" value={istihdamForm.outsource_firma} onChange={e => setIstihdamForm({ ...istihdamForm, outsource_firma: e.target.value })} /></div>
                    <div className="form-group"><label>Müşteride Başlangıç</label><input type="date" value={istihdamForm.outsource_baslangic} onChange={e => setIstihdamForm({ ...istihdamForm, outsource_baslangic: e.target.value })} /></div>
                  </>
                )}
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => setIstihdamDuzenle(false)}>İptal</button>
              </div>
            </form>
          )}
        </div>
      )}

      {/* PERFORMANS */}
      {sekme === 'performans' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <select value={performansYil} onChange={e => setPerformansYil(parseInt(e.target.value))} style={{ width: 'auto' }}>
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
            {duzenleyebilir('performans') && !performansDuzenle && (
              <button className="btn btn-primary btn-sm" onClick={() => setPerformansDuzenle(true)}>
                {performanslar.find(p => p.yil === performansYil) ? 'Düzenle' : '+ Yeni Performans'}
              </button>
            )}
          </div>
          {!performansDuzenle ? (
            <div>
              {performanslar.filter(p => p.yil === performansYil).map(p => (
                <div key={p.id} className="card" style={{ marginBottom: '1rem' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1.25rem' }}>
                    <div style={{ background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', padding: '1rem', textAlign: 'center' }}>
                      <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--mavi)' }}>{p.genel_not || '—'}</div>
                      <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>/ 100 Genel Not</div>
                    </div>
                    <div style={{ background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', padding: '1rem', textAlign: 'center' }}>
                      <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--yesil)' }}>%{p.zam_orani || '—'}</div>
                      <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Zam Oranı</div>
                    </div>
                    <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '1rem' }}>
                      <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '4px' }}>Notlar</div>
                      <div style={{ fontSize: '13px' }}>{p.notlar || '—'}</div>
                    </div>
                  </div>
                  {p.hedefler && p.hedefler.length > 0 && (
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>Performans Hedefleri</p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {p.hedefler.map((h, idx) => (
                          <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
                            <div style={{ flex: 1, fontSize: '14px' }}>{h.hedef}</div>
                            <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', whiteSpace: 'nowrap' }}>Hedef: <strong>%{h.hedef_oran || '—'}</strong></div>
                            <div style={{ width: '120px' }}>
                              <div style={{ background: 'var(--gri-200)', borderRadius: '99px', height: '8px', overflow: 'hidden' }}>
                                <div style={{ background: h.gerceklesme_oran >= h.hedef_oran ? 'var(--yesil)' : 'var(--mavi)', width: Math.min(100, h.gerceklesme_oran || 0) + '%', height: '100%', borderRadius: '99px' }} />
                              </div>
                              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textAlign: 'center', marginTop: '2px' }}>%{h.gerceklesme_oran || 0}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {!performanslar.find(p => p.yil === performansYil) && (
                <div className="card" style={{ textAlign: 'center', padding: '2rem', color: 'var(--yazi-ikincil)' }}>
                  {performansYil} yılı için performans kaydı bulunmuyor.
                </div>
              )}
            </div>
          ) : (
            <div className="card">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                <div className="form-group"><label>Genel Not (0-100)</label><input type="number" min="0" max="100" value={performansForm.genel_not} onChange={e => setPerformansForm({ ...performansForm, genel_not: e.target.value })} /></div>
                <div className="form-group"><label>Zam Oranı (%)</label><input type="number" min="0" max="100" step="0.1" value={performansForm.zam_orani} onChange={e => setPerformansForm({ ...performansForm, zam_orani: e.target.value })} /></div>
                <div className="form-group"><label>Notlar</label><input type="text" value={performansForm.notlar} onChange={e => setPerformansForm({ ...performansForm, notlar: e.target.value })} /></div>
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                  <p style={{ fontSize: '13px', fontWeight: '600' }}>Performans Hedefleri</p>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={hedefEkle}>+ Hedef Ekle</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {performansForm.hedefler.map((h, idx) => (
                    <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 120px 120px auto', gap: '0.5rem', alignItems: 'end' }}>
                      <div className="form-group" style={{ margin: 0 }}>
                        {idx === 0 && <label style={{ fontSize: '12px' }}>Hedef</label>}
                        <input type="text" value={h.hedef} onChange={e => hedefGuncelle(idx, 'hedef', e.target.value)} placeholder="Hedef açıklaması" />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {idx === 0 && <label style={{ fontSize: '12px' }}>Hedef %</label>}
                        <input type="number" min="0" max="100" value={h.hedef_oran} onChange={e => hedefGuncelle(idx, 'hedef_oran', e.target.value)} placeholder="%" />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {idx === 0 && <label style={{ fontSize: '12px' }}>Gerçekleşme %</label>}
                        <input type="number" min="0" max="100" value={h.gerceklesme_oran} onChange={e => hedefGuncelle(idx, 'gerceklesme_oran', e.target.value)} placeholder="%" />
                      </div>
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => hedefSil(idx)}>✕</button>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                <button className="btn btn-primary" disabled={yukleniyor} onClick={handlePerformansKaydet}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                <button className="btn btn-secondary" onClick={() => setPerformansDuzenle(false)}>İptal</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* İZİN GEÇMİŞİ */}
      {sekme === 'izinler' && (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {izinler.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>İzin geçmişi bulunmuyor.</div>
          ) : (
            <div className="tablo-wrapper">
              <table>
                <thead><tr><th>İzin Türü</th><th>Başlangıç</th><th>Bitiş</th><th>Gün</th><th>Durum</th></tr></thead>
                <tbody>
                  {izinler.map(i => (
                    <tr key={i.id}>
                      <td>{i.izin_turu}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(i.baslangic_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(i.bitis_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{i.gun_sayisi}</td>
                      <td><span className={'badge ' + (i.durum === 'onaylandi' ? 'badge-tamamlandi' : i.durum === 'reddedildi' ? 'badge-hata' : 'badge-bekliyor')}>{i.durum}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ZİMMETLER */}
      {sekme === 'zimmetler' && (
        <div>
          {/* Aktif zimmetler */}
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>🖥️ Aktif Zimmetler</h3>
              <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '12px', padding: '3px 10px', borderRadius: '99px', fontWeight: 700 }}>
                {aktifZimmetler.length} adet
              </span>
            </div>
            {aktifZimmetler.length === 0 ? (
              <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
                Bu personele atanmış aktif zimmet bulunmuyor.
              </div>
            ) : (
              <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {aktifZimmetler.map(z => (
                  <div key={z.id} style={{ background: 'var(--gri-50)', borderRadius: '8px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', border: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '24px', flexShrink: 0 }}>
                      {z.kategori === 'Bilgisayar' ? '💻' : z.kategori === 'Telefon' ? '📱' : z.kategori === 'Araç' ? '🚗' : z.kategori === 'Tablet' ? '📱' : '🖥️'}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{z.zimmet_ad}</div>
                      <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>
                        {z.kategori}{z.marka ? ` · ${z.marka}` : ''}{z.model ? ` ${z.model}` : ''}{z.seri_no ? ` · SN: ${z.seri_no}` : ''}
                      </div>
                      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>
                        📅 Atandı: {fmt(z.atama_tarihi)} {z.atayan_ad ? `· ${z.atayan_ad} tarafından` : ''}
                      </div>
                      {z.atama_notu && <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>📝 {z.atama_notu}</div>}
                    </div>
                    <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '11px', padding: '3px 10px', borderRadius: '99px', fontWeight: 700, flexShrink: 0 }}>
                      Atandı
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Geçmiş zimmetler */}
          {gecmisZimmetler.length > 0 && (
            <div className="card">
              <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '600', margin: 0, color: 'var(--yazi-ikincil)' }}>Geçmiş Zimmetler</h3>
              </div>
              <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {gecmisZimmetler.map(z => (
                  <div key={z.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', opacity: 0.7 }}>
                    <div style={{ fontSize: '18px' }}>
                      {z.kategori === 'Bilgisayar' ? '💻' : z.kategori === 'Telefon' ? '📱' : '🖥️'}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}><s>{z.zimmet_ad}</s></div>
                      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>
                        {fmt(z.atama_tarihi)} → {fmt(z.iade_tarihi)}
                        {z.iade_notu && ` · ${z.iade_notu}`}
                      </div>
                    </div>
                    <span style={{ background: '#F3F4F6', color: '#9CA3AF', fontSize: '11px', padding: '3px 10px', borderRadius: '99px', fontWeight: 600 }}>İade</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* EĞİTİMLER */}
      {sekme === 'egitimler' && (
        <div>
          {egitimler.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: '2rem', color: 'var(--yazi-ikincil)' }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>📚</div>
              Bu personele atanmış eğitim bulunmuyor.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {egitimler.map(eg => (
                <div key={eg.id} className="card">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '4px' }}>{eg.egitim_adi}</h3>
                      <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--yazi-ikincil)', flexWrap: 'wrap' }}>
                        <span>Atanma: {fmt(eg.atama_tarihi)}</span>
                        {eg.bitis_tarihi && <span>Bitiş: {fmt(eg.bitis_tarihi)}</span>}
                        {eg.tamamlanma_tarihi && <span style={{ color: 'var(--yesil)' }}>Tamamlandı: {fmt(eg.tamamlanma_tarihi)}</span>}
                      </div>
                    </div>
                    <span className={'badge ' + (eg.durum === 'tamamlandi' ? 'badge-tamamlandi' : eg.bitis_tarihi && new Date(eg.bitis_tarihi) < new Date() ? 'badge-hata' : 'badge-bekliyor')}>
                      {eg.durum === 'tamamlandi' ? 'Tamamlandı' : eg.bitis_tarihi && new Date(eg.bitis_tarihi) < new Date() ? 'Süresi Geçti' : 'Devam Ediyor'}
                    </span>
                  </div>
                  {eg.sertifika_adi && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)' }}>
                      <span>🏆</span>
                      <span style={{ fontSize: '13px', color: 'var(--yesil)', fontWeight: '500' }}>Sertifika Yüklendi: {eg.sertifika_adi}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default PersonelKartiPage;
